// extracted by mini-css-extract-plugin
export default {"badge":"style_badge__eQwPZ","text":"style_text__A32Jt","product_badge":"style_product_badge__sMeim","dinamic_btn_bage":"style_dinamic_btn_bage__twKwA"};